
function startsWith(str, pattern) {
	return (str.match("^"+pattern) == pattern);
}

function endsWith(str, pattern) {
	return (str.match(pattern+"$") == pattern);
}

function expand(item, subjectTag, messageTag) {

	var msg = "msg-" + item;
	var subj = "subj-" + item;

	//Get all elements on the page
	var subjectTags = document.getElementsByTagName(subjectTag);

	//Loop through subjects
	for(var i = 0; i < subjectTags.length; i++) {
		var s_tag = subjectTags[i].id;

		if(startsWith(s_tag, "subj-")) {
			var tag = new YAHOO.util.Element(s_tag);

			if(s_tag == subj) {
				if(tag.hasClass('notselected')) {
					tag.replaceClass('notselected' , 'selected');
				}
			} else {
				if(tag.hasClass('selected')) {
					tag.replaceClass('selected' , 'notselected');
				}	
			}
		}
	}
	var messageTags = document.getElementsByTagName(messageTag);
	//Loop through messages
	for(var j = 0; j < messageTags.length; j++) {
		var m_tag = messageTags[j].id;
		if(startsWith(m_tag, "msg-")) {
			var tag = new YAHOO.util.Element(m_tag);
			if(m_tag == msg) {

				if(tag.getStyle('display') == displayStatus){
					tag.setStyle('display', 'none');
				}
				else{
					tag.setStyle('display', displayStatus);
				}
			} else {
				tag.setStyle('display', 'none');
			}
		}
	}
	return false;
};
define("legacy/support/support", function(){});

